module.exports = __webpack_public_path__ + "static/media/final_04.395ff5e8.jpg";